<div class="d-flex pickup-list">
  <div class="col-12 pr-0 pl-0">
    <div class="p-inputgroup" [ngClass]="{'error-border-1':errorObj?.type ==='error','warning-border-1':errorObj?.type ==='warning'}">
      <p-multiselect
        resetFilterOnHide="true"
        #mSelect
        [options]="allFields"
        [(ngModel)]="selected"
        panelStyleClass="pick-list-multiselect"
        optionLabel="name"
        [display]="multiSelectDisplay"
        dataKey="sid"
        [ngClass]="{ 'rowgroup-or-multisort': element?.name === 'groupsOnColumn' || element?.name === 'sortFields' }"
        (onChange)="updateValues($event)"
        appendTo="body"
        [disabled]="disableField"
        optionDisabled="isDisabled"
        (click)="onDropdownClick($event, mSelect)"
      >
        <ng-template let-fields #item>
          <div
            class="multi-items"
            tabindex="0"
            (click)="$event.stopPropagation()"
            (keyup.enter)="$event.stopPropagation()"
          >
            <span class="label">
              <span>{{ fields.name }}</span>
              <span class="font-italic search-label">
                {{ getSearchLabel(fields) }}
              </span>
            </span>
          </div>
        </ng-template>

        <ng-template let-selectedItems #selectedItems>
          <ng-container *ngFor="let selectedItem of selectedItems">
            <div class="p-multiselect-token p-highlight">
              <span class="p-multiselect-token-label">
                <span>{{ selectedItem?.name }}</span>
                <span class="sorting-icons" *ngIf="element.name === 'sortFields' && selectedItem.sortOrder">
                  <i *ngIf="selectedItem.sortOrder === 'asc'" class="pi pi-sort-amount-up-alt"></i>
                  <i *ngIf="selectedItem.sortOrder === 'desc'" class="pi pi-sort-amount-down"></i>
                </span>
              </span>
              <span
                class="p-multiselect-token-icon pi pi-times-circle"
                (click)="removeSelectedItem(selectedItem, $event)"
                (keyup.enter)="removeSelectedItem(selectedItem, $event)"
                tabindex="1"
                aria-label="Remove selected items"
              >
              </span>
            </div>
          </ng-container>
        </ng-template>
      </p-multiselect>

      <p-button
        *ngIf="!disableField"
        type="button"
        pRipple
        icon="pi pi-pencil"
        class="hover-override"
        styleClass="p-button-warn"
        title="Reorder"
        (onClick)="togglePickList($event)"
      />
      <i class="fa fa-exclamation-circle error-icon-1" *ngIf="errorObj?.type==='error'" (mouseenter)="toggleWarningPopup()" (mouseleave)="toggleWarningPopup()"></i>
       <i class="fa fa-exclamation-circle warning-icon-1" *ngIf="errorObj?.type==='warning'" (mouseenter)="toggleWarningPopup()" (mouseleave)="toggleWarningPopup()"></i>
    </div>
    <div class="warning-wrapper" *ngIf="showPopup && errorObj?.errorMsg">
          <div [ngClass]="{'warning-popup':errorObj?.type === 'warning', 'error-popup':errorObj?.type === 'error'}">
            <div class="warning-header">
              <p>{{ errorObj?.type === 'warning' ? 'Warning' : 'Error' }}</p>
            </div>
            {{ errorObj?.errorMsg }}
          </div>
        </div>
  </div>
</div>
<p-dialog
  [modal]="true"
  [(visible)]="showPickList"
  (onHide)="closeDialog($event)"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '70vw' }"
  appendTo="body"
  [closable]="false"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
>
  <ng-template pTemplate="header">
    <span class="dialog-header">
      {{ (pageName || currentTablename) + (menulabel ? ' : ' + menulabel : '') + ' - ' }}
      {{ 'SELECT_REORDER' | translate }}
      <span class="dialog-subheader">{{ label ? ' : ' + label : '' }}</span>
    </span>
  </ng-template>
  <p-picklist
    [source]="source"
    [target]="target"
    [responsive]="true"
    sourceHeader="Available Fields"
    targetHeader="Selected Fields"
    dragdrop="true"
    filterBy="name"
    (onMoveToTarget)="onMoveToTarget($event)"
    (onMoveAllToTarget)="onMoveToTarget($event)"
    sourceFilterPlaceholder="Search by name"
    targetFilterPlaceholder="Search by name"
    (onTargetReorder)="onTargetReorder($event)"
    (onMoveToSource)="onMoveToSource($event)"
    (onMoveAllToSource)="onMoveToSource($event)"
    [disabled]="disableField"
    *ngIf="showPickList"
  >
    <ng-template let-property #item>
      <div class="property-detail">
        <span>
          <span>{{ property.name }}</span>
          <div class="toggle-container" *ngIf="element.name === 'sortFields' && target?.includes(property)">
            <button
              type="button"
              class="toggle-btn left"
              [ngClass]="{ active: property.sortOrder === 'asc' }"
              (click)="setSortOrder(property, 'asc', $event)"
            >
              <i class="pi pi-sort-amount-up-alt pl-1"></i>
              asc
            </button>
            <button
              type="button"
              class="toggle-btn right"
              [ngClass]="{ active: property.sortOrder === 'desc' }"
              (click)="setSortOrder(property, 'desc', $event)"
            >
              <i class="pi pi-sort-amount-down pl-1"></i>
              desc
            </button>
          </div>
          <span class="font-italic search-label">
            {{ getSearchLabel(property) }}
          </span>
        </span>
      </div>
    </ng-template>
    <ng-template #emptymessagesource>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
    <ng-template #emptymessagetarget>
      <div class="property-detail text-center">
        <span>No Fields Available</span>
      </div>
    </ng-template>
  </p-picklist>
  <ng-template pTemplate="footer">
    <button
      type="button"
      [ngClass]="isBetaAccessPrivilegeConsumable ? 'button-outlined mr-2' : 'btn btn-primary cancel-btn'"
      (click)="closeDialog($event)"
    >
      {{ 'CANCEL' | translate }}
    </button>
    <button
      type="button"
      [ngClass]="isBetaAccessPrivilegeConsumable ? 'button-filled' : 'btn btn-primary btn-sm'"
      (click)="savePicklist()"
      [disabled]="disableField"
    >
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
</p-dialog>
